import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { notificationShow } from 'modules/Notifications/actions'
import { ACTIVATE, ADMITAD_AUTH, LOGOUT, SET_AUTH, TRY_START_SESSION } from 'modules/Auth/types'

/**
 * Custom hook for Auth module dispatch logic
 */
export const useAuth = () => {
  const dispatch = useDispatch()

  const setAuth = useCallback(
    (payload) => {
      dispatch({
        type: SET_AUTH,
        payload,
      })
    },
    [dispatch],
  )

  const tryStartSession = useCallback(() => {
    dispatch({ type: TRY_START_SESSION })
  }, [dispatch])

  const logout = useCallback(() => {
    dispatch({ type: LOGOUT })
  }, [dispatch])

  const startSessionOrLogout = useCallback(() => {
    dispatch({
      type: localStorage.getItem('refresh_token') ? TRY_START_SESSION : LOGOUT,
    })
  }, [dispatch])

  const showNotification = useCallback(
    (payload) => {
      dispatch(notificationShow(payload))
    },
    [dispatch],
  )

  const activate = useCallback(
    (payload, meta) =>
      dispatch({
        type: ACTIVATE,
        payload,
        meta,
      }),
    [dispatch],
  )

  const admitadAuth = useCallback(
    (payload) => {
      dispatch({
        type: ADMITAD_AUTH,
        payload,
      })
    },
    [dispatch],
  )

  return {
    setAuth,
    tryStartSession,
    logout,
    startSessionOrLogout,
    showNotification,
    activate,
    admitadAuth,
  }
}
